import Component from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/components/parser.vue'
wx.createComponent(Component)